<template>
  <div class="container">
    <!--会议室信息  -->
    <div class="room_mess">
      <h2>会议室</h2>
      <div class="room_detail">
        <div class="room_detail_left">
          <div class="left_title">
            <img src="@/assets/images/themes/icon_location_0.png" />
            <span>{{metingRoom.name}}</span>
          </div>
          <p class="left_text"><span>面积{{metingRoom.area}}㎡</span><span>座位{{metingRoom.num}}人</span></p>
        </div>
        <div class="room_detail_right">
          <img :src="metingRoom.images" />
        </div>
      </div>
    </div>
    <!-- 预订信息 -->
    <div class="appoint_mess">
      <h2>预订信息</h2>
      <ul>
        <li>
          <span>预订时段</span>
          <p>{{selectDay}} {{activeWeekDay}} {{timeList[selectStart].time}}-{{timeList[selectEnd].time}}</p>
        </li>
        <li>
          <span>会议主题</span>
          <p>{{theme}}</p>
        </li>
        <li>
          <span>预订人</span>
          <p>{{common.userTenantInfo.userName}}</p>
        </li>
        <li>
          <span>手机号</span>
          <p>{{common.userTenantInfo.phone}}</p>
        </li>
      </ul>
    </div>
     <!-- 底部按钮 -->
    <footer class="footer_box">
      <p @click="confirmPay">确认下单</p>
    </footer>
  </div>
</template>
<script>
import util from "../../../utils/util";
import { mapState } from "vuex";
import {insertMeetingOrderSmart,getMeetingRoomDetailByIdSmart} from "../../../utils/api";
export default {
  name: "roomPay",
  components: {},
  data() {
    return {
      orderNo: "",
      lastPayTime: "",
      needYudingName:true,
      metingRoom: {},
      maxDiscountAmount: "", //最大优惠额度
      lists: [], //优惠券列表
      listsLength: 0,
      showCoupon: false, //显示优惠券列表
      orderInfo: {},
      activeAmountDiscount: 0, //无优惠券优惠 折扣
      chargeList: [], //付费项目
      chargePrice: 0,
      activeCompanyObj: {}, //公司免费时长
      freePrice: 0,
      userName: "",
      userCompanyName:'',
      bondItemAmount: 0, //优惠券优惠的价格
      activeDiscountMode: "1", //1满减，2折扣
      bondItemId: "", //优惠券id
      tel: "",
      offlinepay:0,//offlinepay这个字段 1代表开启线下支付 其他代表关闭线下支付
      handle: function(e){
            e.preventDefault()
        },
    };
  },
  filters: {
    date: function(data) {
      if (data) {
        return data.split('-').join('.')
      }
    }
  },
  watch: {
    showCoupon: function (val) { //防止后面页面滚动
      console.log("in showCoupon")
      if(val) {
          document.getElementsByTagName('body')[0].addEventListener('touchmove', this.handler, { passive: false });
      } else {
          document.getElementsByTagName('body')[0].removeEventListener('touchmove', this.handler, { passive: false });
      }
    }
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  created() {
    let options = this.$route.query;
    this.selectDay = options.selectDay;
    this.activeWeekDay = options.activeWeekDay;
    this.timeList = JSON.parse(options.timeList);
    this.selectStart = options.selectStart;
    this.selectEnd = options.selectEnd;
    this.theme = options.theme;
    this.getMeetingRoomDetailByIdSmart();
  },
  methods: {
    // 获取会议室数据
    getMeetingRoomDetailByIdSmart() {
      util.showLoading("加载中...");
      getMeetingRoomDetailByIdSmart({
        meetingRoomId: this.$route.query.id || ''
      }).then(res => {
        console.log(res)
        util.hideLoading();
        if (res.res && res.res.code === 10000 && res.body) {
          this.metingRoom = res.body.room;
        }
      });
    },
    // 创建订单
    confirmPay() {
      let timeList = this.timeList;
      let beginTime = timeList[this.selectStart].time;
      let endTime = timeList[this.selectEnd].time;
      let payDate = timeList[this.selectStart].date;
      let payTime = ((this.selectEnd - this.selectStart) / 2).toFixed(1);
      let params = {
        userId: this.common.userId,
        companyId:this.common.userTenantInfo.companyId,
        meetingRoomId:this.$route.query.id,
        payDate: payDate,
        payTime: payTime,
        beginTime: beginTime,
        endTime: endTime,
        userName: this.common.userTenantInfo.userName,
        phone: this.common.userTenantInfo.phone,
        theme:this.$route.query.theme
      };
      util.showLoading("下单中...");
      insertMeetingOrderSmart(params).then(res => {
        console.log(res);
        util.hideLoading();
        if (res.res && res.res.code === 10000) {
          util.showToast('预订成功!')
          this.$store.commit('isChange', true);
          setTimeout(() => {
            this.$router.go(-1)
          }, 1500);
        } else {
          util.showToast(res.res.msg, 2000);
        }
      });
    },
  }
};
</script>
<style lang="less" scoped>
@import "../../../assets/css/common.less";
.container {
  background: @colore;
}
h2{
  height:44px;
  line-height: 44px;
  font-size:32px;
  font-weight:bold;
  color:rgba(51,51,51,1);
  border-bottom:2px solid #EAEAEA;
  padding-bottom:28px;
  margin-bottom:28px;
}
.room_mess{
  padding:28px;
  border-radius: 8px;
  background:#fff;
  margin:20px;
  .room_detail{
    .flex();
    justify-content: space-between;
    .room_detail_left{
      flex:1;
      .left_title{
        .flex();
        align-items: center;
        margin-bottom:20px;
        img{
          display:block;
          width:36px;
          height:36px;
          margin-right:10px;
        }
        span{
          font-size:36px;
          font-weight:bold;
          color:rgba(51,51,51,1);
          line-height:50px;
        }
      }
      .left_text{
        .flex();
        margin-bottom:8px;
        span{
          height:44px;
          border-radius:8px;
          border:2px solid rgba(218,218,218,1);
          line-height: 40px;
          text-align: center;
          padding:0 8px;
          font-size:24px;
          color:rgba(102,102,102,1);
          margin-right:10px;
          box-sizing:border-box;
        }
      }
    }
    .room_detail_right{
      width:200px;
      height:150px;
      img{
        display: block;
        width:200px;
        height:150px;
        border-radius: 8px;
      }
    }
  }
}
.appoint_mess{
  padding:28px;
  border-radius: 8px;
  background:#fff;
  margin:20px;
  padding-top:28px;
  li{
    .flex();
    padding-bottom: 28px;
    span{
      width:140px;
      font-size:28px;
      color:rgba(153,153,153,1);
      line-height:40px;
    }
    p{
      flex:1;
      flex-wrap: wrap;
      font-size:28px;
      color:rgba(51,51,51,1);
      line-height:40px;
    }
  }
}
.footer_box{
  position:fixed;
  bottom:0;right:0;left:0;
  background:#fff;
  padding:16px 20px;
  box-sizing: border-box;
  p{
    height:88px;
    background:#1740DA;
    border-radius:8px;
    text-align: center;
    line-height:88px;
    font-size:32px;
    color:rgba(255,255,255,1);
  }
}
</style>